import { AppThunk } from '../../../store/rootReducer';
import { FilterOption } from '../../layout/types/layout-state.type';
import {
  clusterByFilterSelector,
  projectedBaseClusterSelector,
} from '../selectors/cluster.selectors';
import * as layoutActions from '../../layout/actions/layout.actions';
import { selectNewCluster } from './select-new-cluster.thunk';
import * as beatsActions from '../../beats/beats.actions';
import * as clusterActions from '../actions/cluster.actions';

export const updateClusterFilterOption =
  (filterOption: FilterOption): AppThunk =>
  async (dispatch, getState) => {
    const selectedCluster = projectedBaseClusterSelector(getState());
    const clustersByNewFilter = clusterByFilterSelector(filterOption)(
      getState(),
    );

    if (clustersByNewFilter.length === 0) {
      dispatch(beatsActions.load({ beats: [] }));
      dispatch(
        clusterActions.selectClusters({
          clusterIds: new Set(),
        }),
      );
    } else if (
      (filterOption !== 'All' &&
        selectedCluster?.classification !== filterOption) ||
      selectedCluster == null
    ) {
      const newlySelectedCluster = clustersByNewFilter[0];
      dispatch(selectNewCluster(newlySelectedCluster));
    }

    dispatch(layoutActions.update({ update: { filterOption } }));
  };
